<template>
  <v-card class="mx-auto" max-width="500">
    <v-toolbar color="blue" dark>
      <v-checkbox
        color="yellow"
        v-if="listaCoordenadas.length > 0"
        class="mt-6"
        v-model="SeleccionarTodos"
      >
      </v-checkbox>
      <v-spacer></v-spacer>
      <v-toolbar-title> Coordenadas compartidas</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-list two-line class="overflow-y-auto" max-height="700">
      <v-list-item-group v-model="selected">
        <template v-for="(item, index) in items">
          <v-list-item :key="item.title">
            <template>
              <v-list-item-action>
                <v-checkbox
                  v-model="listaCoordenadas"
                  :value="item.title"
                  multiple
                  color="primary"
                >
                </v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="mb-2"
                  >Numero de asistencia: {{ item.title }}</v-list-item-title
                >

                <v-list-item-subtitle class="text--primary mb-2"
                  >Latitude: {{ item.headline }}</v-list-item-subtitle
                >

                <v-list-item-subtitle class="text--primary"
                  >Longitude: {{ item.subtitle }}</v-list-item-subtitle
                >
              </v-list-item-content>

              <v-list-item-action @click="openDialog(item)">
                <v-icon color="grey lighten-1" dense>
                  fas fa-external-link-alt
                </v-icon>
              </v-list-item-action>
            </template>
          </v-list-item>

          <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>

    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="500"
    >
      <v-card>
        <v-toolbar class="title" color="primary" dark
          >¿Que desea hacer?</v-toolbar
        >
        <v-card-text class="title pt-5 pb-1 font-weight-black"
          >Numero de asistencia: {{ numeroAsistencia }}</v-card-text
        >
        <v-card-actions class="justify-end">
          <v-btn color="green" outlined @click="abrirGoogleMaps()"
            >Abrir en Google Maps</v-btn
          >
          <v-btn color="red" outlined @click="borrarCoordenadas()"
            >Eliminar estas coordenadas</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay v-model="overlay" z-index="0">
      <lottie-player
        autoplay
        loop
        mode="normal"
        src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
        style="width: 320px"
      >
      </lottie-player>
    </v-overlay>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        v-if="listaCoordenadas.length > 0"
        @click="EliminarSeleccionarTodos()"
      >
        Eliminar seleccionados
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { dbCoordenadas } from "../main";
export default {
  data() {
    return {
      selected: [2],
      items: [],
      dialog: false,
      numeroAsistencia: "",
      latitude: 0,
      longitude: 0,
      overlay: true,
      listaCoordenadas: [],
      count: 0,
    };
  },
  created() {
    this.obtenerCoordenadas();
  },
  computed: {
    SeleccionarTodos: {
      set(val) {
        this.listaCoordenadas = [];
        if (val) {
          for (let i = 0; i < this.count; i++) {
            this.listaCoordenadas[i] = this.items[i].title;
          }
        }
      },
      get() {
        return this.listaCoordenadas.length === this.count;
      },
    },
  },
  methods: {
    obtenerCoordenadas() {
      let me = this;
      dbCoordenadas.on("value", function (data) {
        me.items = [];
        data.forEach(function (childSnapshot) {
          me.items.push({
            action: childSnapshot.key,
            headline: childSnapshot.val().latitude,
            subtitle: childSnapshot.val().longitude,
            title: childSnapshot.key,
          });
          me.count++;
        });
        me.overlay = false;
      });
    },
    openDialog(item) {
      this.dialog = true;
      this.numeroAsistencia = item["title"];
      this.latitude = item["headline"];
      this.longitude = item["subtitle"];
    },
    abrirGoogleMaps() {
      var url =
        "http://www.google.com/maps/place/" +
        this.latitude +
        "," +
        this.longitude;
      window.open(url, "_blank", "location=yes");
    },
    EliminarSeleccionarTodos() {
      let me = this;
      me.overlay = true;
      console.log("seleccionados", me.listaCoordenadas);
      for (let i = 0; i < me.listaCoordenadas.length; i++) {
        dbCoordenadas
          .child(this.listaCoordenadas[i])
          .remove()
          .then(function () {
            me.overlay = false;
            me.listaCoordenadas = [];
          })
          .catch(function (error) {
            console.log("ERROR", error);
          });
      }
    },
    borrarCoordenadas() {
      let me = this;
      me.overlay = true;
      dbCoordenadas
        .child(me.numeroAsistencia)
        .remove()
        .then(function () {
          me.dialog = false;
          me.overlay = false;
        })
        .catch(function (error) {
          console.log("ERROR", error);
        });
    },
  },
};
</script>